// extracted by mini-css-extract-plugin
export default {"row":"reportPage_row__9dZrv","column":"reportPage_column__Ckvfu"};